export const GOOGLE_CLOUD_FUNCTIONS_URL =
  'https://europe-west3-the-orca.cloudfunctions.net';

export const CONTENTFUL_URL = 'https://cdn.contentful.com';

export const CONTENTFUL_SPACE_ID = 'toog96l2q1kc';
